// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_q7-0";
export var animationContainer = "_q7-1";
export var itemPrice = "_q7-a";
export var itemizedContent = "_q7-9";
export var itemizedHeader = "_q7-7";
export var itemizedRow = "_q7-8";
export var itemizedSection = "_q7-6";
export var modalContent = "_q7-2";
export var orderName = "_q7-3";
export var refundOption = "_q7-4";
export var refundOptionsContainer = "_q7-5";
export var shippingLabel = "_q7-b";
export var totalRow = "_q7-c";